import { gql } from "generated-graphql";

export const PROCESSED_MANIFEST_CORRECTION_STATS_QUERY = gql(`
  query ProcessedManifestCorrectionStats(
    $tenantId: ID!
    $shippedYear: Int!
    $vendorSource: String
  ) {
    processedManifestCorrectionStats(
      tenantId: $tenantId
      shippedYear: $shippedYear
      vendorSource: $vendorSource
    ) {
      onTime
      late
      overdue
      inWindow
    }
  }
`);

export const PROCESSED_MANIFEST_CORRECTION_STATS_BY_VENDOR_QUERY = gql(`
  query ProcessedManifestCorrectionStatsByVendor($tenantId: ID!, $shippedYear: Int!) {
    processedManifestCorrectionStatsByVendor(tenantId: $tenantId, shippedYear: $shippedYear) {
      vendor
      total
      corrected30
      avgDaysToCorrect
    }
  }
`);

export const PROCESSED_MANIFEST_CORRECTION_STATS_BY_MONTH_QUERY = gql(`
  query ProcessedManifestCorrectionStatsByMonth(
    $tenantId: ID!
    $shippedYear: Int!
    $vendorSource: String
  ) {
    processedManifestCorrectionStatsByMonth(
      tenantId: $tenantId
      shippedYear: $shippedYear
      vendorSource: $vendorSource
    ) {
      month
      total
      corrected30
      onTime
      late
      overdue
      pending
      avgDaysToCorrect
    }
  }
`);

export const MANIFEST_DISCREPANCY_CLOSURE_STATS_QUERY = gql(`
  query ManifestDiscrepancyClosureStats(
    $tenantId: ID!
    $shippedYear: Int!
    $vendorSource: String
  ) {
    manifestDiscrepancyClosureStats(
      tenantId: $tenantId
      shippedYear: $shippedYear
      vendorSource: $vendorSource
    ) {
      resolvedCount
      avgDaysToClosure
      medianDaysToClosure
      minDaysToClosure
      maxDaysToClosure
    }
  }
`);

export const MANIFEST_DISCREPANCY_CLOSURE_STATS_BY_VENDOR_QUERY = gql(`
  query ManifestDiscrepancyClosureStatsByVendor(
    $tenantId: ID!
    $shippedYear: Int!
    $shippedMonth: Int
  ) {
    manifestDiscrepancyClosureStatsByVendor(
      tenantId: $tenantId
      shippedYear: $shippedYear
      shippedMonth: $shippedMonth
    ) {
      vendor
      resolvedCount
      avgDaysToClosure
      medianDaysToClosure
      minDaysToClosure
      maxDaysToClosure
    }
  }
`);

export const MANIFEST_DISCREPANCY_FLAGGED_SOURCE_STATS_QUERY = gql(`
  query ManifestDiscrepancyFlaggedSourceStats(
    $tenantId: ID!
    $shippedYear: Int!
    $vendorSource: String
  ) {
    manifestDiscrepancyFlaggedSourceStats(
      tenantId: $tenantId
      shippedYear: $shippedYear
      vendorSource: $vendorSource
    ) {
      source
      total
      corrected
      corrected30
      avgDaysToClose
    }
  }
`);

export const MANIFEST_DISCREPANCY_FLAGGED_SOURCE_STATS_BY_MONTH_QUERY = gql(`
  query ManifestDiscrepancyFlaggedSourceStatsByMonth(
    $tenantId: ID!
    $shippedYear: Int!
    $vendorSource: String
  ) {
    manifestDiscrepancyFlaggedSourceStatsByMonth(
      tenantId: $tenantId
      shippedYear: $shippedYear
      vendorSource: $vendorSource
    ) {
      month
      regulatorTotal
      regulatorCorrected
      encampTotal
      encampCorrected
    }
  }
`);

export const MANIFEST_DISCREPANCY_FLAGGED_SOURCE_STATS_BY_VENDOR_QUERY = gql(`
  query ManifestDiscrepancyFlaggedSourceStatsByVendor($tenantId: ID!, $shippedYear: Int!) {
    manifestDiscrepancyFlaggedSourceStatsByVendor(tenantId: $tenantId, shippedYear: $shippedYear) {
      vendor
      regulatorTotal
      regulatorCorrected
      encampTotal
      encampCorrected
    }
  }
`);

export const MANIFEST_DISCREPANCY_CLOSURE_STATS_BY_MONTH_QUERY = gql(`
  query ManifestDiscrepancyClosureStatsByMonth(
    $tenantId: ID!
    $shippedYear: Int!
    $vendorSource: String
  ) {
    manifestDiscrepancyClosureStatsByMonth(
      tenantId: $tenantId
      shippedYear: $shippedYear
      vendorSource: $vendorSource
    ) {
      month
      resolvedCount
      avgDaysToClosure
      medianDaysToClosure
      minDaysToClosure
      maxDaysToClosure
    }
  }
`);
